import { toast } from 'react-toastify'

class ErrorHandler extends Error {
  errors: any
  _message = ''

  constructor(data: any, hideToastr?: boolean) {
    super('Error')
    this.errors = data?.errors
    this._message = data?.errors?._base

    if (this.errors?._base && !hideToastr) {
      toast.warning(this.errors?._base)
    }
  }
}

export default ErrorHandler
